import { IconButton } from 'Components/Button';
import { ICONS } from 'Utils/icons';
import { Badge, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Fragment } from 'react';

// Attribute row for numbered list of attributes on Repo Details page 
function DetailRow ({num, attribute, value, tooltipAction}) {
    return (
        <Fragment key={num}>
            <div className="d-flex flex-row align-items-start  gap-2 detail-row-attr-con">
                {/* Line number */}
                <Badge bg="event-count" className={""}>{num}</Badge>
                <div>
                    <div className="color-base-black body regular d-flex gap-2">
                        {/* Attribute Name */}
                        {attribute} 
                        {
                            // If attribute is #4 (HL7 Data Type), include tooltip
                            num == 4
                            ?
                                <OverlayTrigger
                                    //show={true}
                                    overlay={
                                        <Tooltip id="moreInfoDesc" className="bodyS regular public-tooltip-light text-start">
                                            Click for more information
                                        </Tooltip>
                                    }
                                >
                                    <IconButton 
                                        className="tooltip-btn-trigger blue-fill" 
                                        hiddenText="Click for more information" 
                                        variant="comp-plain" 
                                        icon={ICONS.repoInfoTooltipTrigger}
                                        onClick={()=>{
                                            tooltipAction();
                                        }}
                                    ></IconButton>
                                </OverlayTrigger>
                            :   null
                        }
                    </div>
                    {/* Mobile display attribute value */}
                    <div className="d-block d-lg-none color-base-black body regular overflow-wrap-any">{value}</div>
                </div>
            </div>
            {/* Desktop display attribute value */}
            <div className="d-none d-lg-block color-base-black body regular overflow-wrap-any">{value}</div>
    </Fragment>);
}

export default DetailRow;
